@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.share_application.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.share_application.generated.resources/"

internal val Res.string.feature_apply_share_error_frequency_required: StringResource by lazy {
      StringResource("string:feature_apply_share_error_frequency_required", "feature_apply_share_error_frequency_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 80),
      ))
    }

internal val Res.string.feature_apply_share_error_price_required: StringResource by lazy {
      StringResource("string:feature_apply_share_error_price_required", "feature_apply_share_error_price_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91, 76),
      ))
    }

internal val Res.string.feature_apply_share_error_server: StringResource by lazy {
      StringResource("string:feature_apply_share_error_server", "feature_apply_share_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168, 140),
      ))
    }

internal val Res.string.feature_apply_share_error_shares_required: StringResource by lazy {
      StringResource("string:feature_apply_share_error_shares_required", "feature_apply_share_error_shares_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309, 77),
      ))
    }

internal val Res.string.feature_apply_share_error_submit_failed: StringResource by lazy {
      StringResource("string:feature_apply_share_error_submit_failed", "feature_apply_share_error_submit_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 123),
      ))
    }

internal val Res.string.feature_apply_share_error_too_many_attempts: StringResource by lazy {
      StringResource("string:feature_apply_share_error_too_many_attempts", "feature_apply_share_error_too_many_attempts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 511, 119),
      ))
    }

internal val Res.string.feature_apply_share_frequency_invalid: StringResource by lazy {
      StringResource("string:feature_apply_share_frequency_invalid", "feature_apply_share_frequency_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 631, 85),
      ))
    }

internal val Res.string.feature_apply_share_label_currency: StringResource by lazy {
      StringResource("string:feature_apply_share_label_currency", "feature_apply_share_label_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 717, 54),
      ))
    }

internal val Res.string.feature_apply_share_label_current_price: StringResource by lazy {
      StringResource("string:feature_apply_share_label_current_price", "feature_apply_share_label_current_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 772, 67),
      ))
    }

internal val Res.string.feature_apply_share_label_default_savings_account: StringResource by lazy {
      StringResource("string:feature_apply_share_label_default_savings_account", "feature_apply_share_label_default_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 840, 89),
      ))
    }

internal val Res.string.feature_apply_share_label_lockin_frequency: StringResource by lazy {
      StringResource("string:feature_apply_share_label_lockin_frequency", "feature_apply_share_label_lockin_frequency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1006, 62),
      ))
    }

internal val Res.string.feature_apply_share_label_lockin_frequency_type: StringResource by lazy {
      StringResource("string:feature_apply_share_label_lockin_frequency_type", "feature_apply_share_label_lockin_frequency_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 930, 75),
      ))
    }

internal val Res.string.feature_apply_share_label_lockin_period: StringResource by lazy {
      StringResource("string:feature_apply_share_label_lockin_period", "feature_apply_share_label_lockin_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1069, 67),
      ))
    }

internal val Res.string.feature_apply_share_label_minimum_active_period: StringResource by lazy {
      StringResource("string:feature_apply_share_label_minimum_active_period", "feature_apply_share_label_minimum_active_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1137, 83),
      ))
    }

internal val Res.string.feature_apply_share_label_minimum_frequency: StringResource by lazy {
      StringResource("string:feature_apply_share_label_minimum_frequency", "feature_apply_share_label_minimum_frequency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1298, 63),
      ))
    }

internal val Res.string.feature_apply_share_label_minimum_frequency_type: StringResource by lazy {
      StringResource("string:feature_apply_share_label_minimum_frequency_type", "feature_apply_share_label_minimum_frequency_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1221, 76),
      ))
    }

internal val Res.string.feature_apply_share_label_terms: StringResource by lazy {
      StringResource("string:feature_apply_share_label_terms", "feature_apply_share_label_terms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1362, 47),
      ))
    }

internal val Res.string.feature_apply_share_label_total_number_of_shares: StringResource by lazy {
      StringResource("string:feature_apply_share_label_total_number_of_shares", "feature_apply_share_label_total_number_of_shares", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1410, 88),
      ))
    }

internal val Res.string.feature_apply_share_price_invalid: StringResource by lazy {
      StringResource("string:feature_apply_share_price_invalid", "feature_apply_share_price_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 81),
      ))
    }

internal val Res.string.feature_apply_share_section_lockin_period: StringResource by lazy {
      StringResource("string:feature_apply_share_section_lockin_period", "feature_apply_share_section_lockin_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1581, 69),
      ))
    }

internal val Res.string.feature_apply_share_section_minimum_active_period: StringResource by lazy {
      StringResource("string:feature_apply_share_section_minimum_active_period", "feature_apply_share_section_minimum_active_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1651, 85),
      ))
    }

internal val Res.string.feature_apply_share_shares_invalid: StringResource by lazy {
      StringResource("string:feature_apply_share_shares_invalid", "feature_apply_share_shares_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1737, 78),
      ))
    }

internal val Res.string.feature_apply_share_status_failure: StringResource by lazy {
      StringResource("string:feature_apply_share_status_failure", "feature_apply_share_status_failure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1981, 82),
      ))
    }

internal val Res.string.feature_apply_share_status_failure_action: StringResource by lazy {
      StringResource("string:feature_apply_share_status_failure_action", "feature_apply_share_status_failure_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1816, 61),
      ))
    }

internal val Res.string.feature_apply_share_status_failure_tip: StringResource by lazy {
      StringResource("string:feature_apply_share_status_failure_tip", "feature_apply_share_status_failure_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1878, 102),
      ))
    }

internal val Res.string.feature_apply_share_status_success: StringResource by lazy {
      StringResource("string:feature_apply_share_status_success", "feature_apply_share_status_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2257, 70),
      ))
    }

internal val Res.string.feature_apply_share_status_success_action: StringResource by lazy {
      StringResource("string:feature_apply_share_status_success_action", "feature_apply_share_status_success_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2064, 65),
      ))
    }

internal val Res.string.feature_apply_share_status_success_tip: StringResource by lazy {
      StringResource("string:feature_apply_share_status_success_tip", "feature_apply_share_status_success_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2130, 126),
      ))
    }

internal val Res.string.feature_apply_share_unsaved_changes_message: StringResource by lazy {
      StringResource("string:feature_apply_share_unsaved_changes_message", "feature_apply_share_unsaved_changes_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2328, 131),
      ))
    }

internal val Res.string.feature_apply_share_unsaved_changes_title: StringResource by lazy {
      StringResource("string:feature_apply_share_unsaved_changes_title", "feature_apply_share_unsaved_changes_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2460, 73),
      ))
    }

internal val Res.string.feature_share_button_next: StringResource by lazy {
      StringResource("string:feature_share_button_next", "feature_share_button_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2534, 41),
      ))
    }

internal val Res.string.feature_share_label_applicant_name: StringResource by lazy {
      StringResource("string:feature_share_label_applicant_name", "feature_share_label_applicant_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2576, 62),
      ))
    }

internal val Res.string.feature_share_label_product_name: StringResource by lazy {
      StringResource("string:feature_share_label_product_name", "feature_share_label_product_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2639, 56),
      ))
    }

internal val Res.string.feature_share_label_submission_date: StringResource by lazy {
      StringResource("string:feature_share_label_submission_date", "feature_share_label_submission_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2696, 63),
      ))
    }

internal val Res.string.feature_share_navigation_back: StringResource by lazy {
      StringResource("string:feature_share_navigation_back", "feature_share_navigation_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2760, 45),
      ))
    }

internal val Res.string.feature_share_no_products_available: StringResource by lazy {
      StringResource("string:feature_share_no_products_available", "feature_share_no_products_available", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2806, 115),
      ))
    }

internal val Res.string.feature_share_title: StringResource by lazy {
      StringResource("string:feature_share_title", "feature_share_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2922, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_apply_share_error_frequency_required", Res.string.feature_apply_share_error_frequency_required)
  map.put("feature_apply_share_error_price_required", Res.string.feature_apply_share_error_price_required)
  map.put("feature_apply_share_error_server", Res.string.feature_apply_share_error_server)
  map.put("feature_apply_share_error_shares_required", Res.string.feature_apply_share_error_shares_required)
  map.put("feature_apply_share_error_submit_failed", Res.string.feature_apply_share_error_submit_failed)
  map.put("feature_apply_share_error_too_many_attempts", Res.string.feature_apply_share_error_too_many_attempts)
  map.put("feature_apply_share_frequency_invalid", Res.string.feature_apply_share_frequency_invalid)
  map.put("feature_apply_share_label_currency", Res.string.feature_apply_share_label_currency)
  map.put("feature_apply_share_label_current_price", Res.string.feature_apply_share_label_current_price)
  map.put("feature_apply_share_label_default_savings_account", Res.string.feature_apply_share_label_default_savings_account)
  map.put("feature_apply_share_label_lockin_frequency", Res.string.feature_apply_share_label_lockin_frequency)
  map.put("feature_apply_share_label_lockin_frequency_type", Res.string.feature_apply_share_label_lockin_frequency_type)
  map.put("feature_apply_share_label_lockin_period", Res.string.feature_apply_share_label_lockin_period)
  map.put("feature_apply_share_label_minimum_active_period", Res.string.feature_apply_share_label_minimum_active_period)
  map.put("feature_apply_share_label_minimum_frequency", Res.string.feature_apply_share_label_minimum_frequency)
  map.put("feature_apply_share_label_minimum_frequency_type", Res.string.feature_apply_share_label_minimum_frequency_type)
  map.put("feature_apply_share_label_terms", Res.string.feature_apply_share_label_terms)
  map.put("feature_apply_share_label_total_number_of_shares", Res.string.feature_apply_share_label_total_number_of_shares)
  map.put("feature_apply_share_price_invalid", Res.string.feature_apply_share_price_invalid)
  map.put("feature_apply_share_section_lockin_period", Res.string.feature_apply_share_section_lockin_period)
  map.put("feature_apply_share_section_minimum_active_period", Res.string.feature_apply_share_section_minimum_active_period)
  map.put("feature_apply_share_shares_invalid", Res.string.feature_apply_share_shares_invalid)
  map.put("feature_apply_share_status_failure", Res.string.feature_apply_share_status_failure)
  map.put("feature_apply_share_status_failure_action", Res.string.feature_apply_share_status_failure_action)
  map.put("feature_apply_share_status_failure_tip", Res.string.feature_apply_share_status_failure_tip)
  map.put("feature_apply_share_status_success", Res.string.feature_apply_share_status_success)
  map.put("feature_apply_share_status_success_action", Res.string.feature_apply_share_status_success_action)
  map.put("feature_apply_share_status_success_tip", Res.string.feature_apply_share_status_success_tip)
  map.put("feature_apply_share_unsaved_changes_message", Res.string.feature_apply_share_unsaved_changes_message)
  map.put("feature_apply_share_unsaved_changes_title", Res.string.feature_apply_share_unsaved_changes_title)
  map.put("feature_share_button_next", Res.string.feature_share_button_next)
  map.put("feature_share_label_applicant_name", Res.string.feature_share_label_applicant_name)
  map.put("feature_share_label_product_name", Res.string.feature_share_label_product_name)
  map.put("feature_share_label_submission_date", Res.string.feature_share_label_submission_date)
  map.put("feature_share_navigation_back", Res.string.feature_share_navigation_back)
  map.put("feature_share_no_products_available", Res.string.feature_share_no_products_available)
  map.put("feature_share_title", Res.string.feature_share_title)
}
